
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { NgModule,EventEmitter } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { HttpClientModule } from '@angular/common/http';

import { CdkTableModule } from '@angular/cdk/table';
import { CdkTreeModule } from '@angular/cdk/tree';
import { TrvDashboardModule,TrvFormModule ,TrvTabsetModule } from 'trv-ng-common';
//import { DashboardCustomNavComponent } from './components/dashboard/dashboard-custom-nav/dashboard-custom-nav.component';
// import { DashboardCustomRouteComponent } from './components/dashboard/dashboard-custom-route/dashboard-custom-route.component';
// import {DashboardComponent} from './components/dashboard/dashboard.component';
import { AppComponent } from './app.component';
// import { GlobalMessagesComponent } from './components/global-messages/global-messages.component';
//import {DOCUMENT} from '@angular/common';
import { appRoutes } from './routes';
import { olmapComponent } from './components/olmap/olmap.component';
import { TabsComponent } from './components/tabs/tabs.component';
import {MapService} from './shared/services/map.service';
import {FrostmeasurementService} from './shared/services/frostmeasurement.service';
import {olMapEventService} from '../app/shared/services/olEventEmitter.service';
import { StationlistComponent } from './components/stationlist/stationlist.component';
import { StationlistItemComponent } from './components/stationlist-item/stationlist-item.component';
import { InformationComponent } from './components/information/information.component';


@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,    
    olmapComponent,
    TabsComponent,
    StationlistComponent,
    StationlistItemComponent,
    InformationComponent
    
   //DashboardComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule.forRoot(appRoutes),
    FontAwesomeModule,
    HttpClientModule,
        // TRV modules  
    TrvDashboardModule,
    TrvTabsetModule,
    TrvFormModule,
    CdkTableModule,
    CdkTreeModule
    
  ],
  providers: [
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    olMapEventService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

